import React, { createContext, useState } from "react";

export const GlobalContext = createContext();

const GlobalContextProvider = (props) => {
  const [show, setShow] = useState(false);
  const [isHeroActive, setIsHeroActive] = useState(true);
  return (
    <GlobalContext.Provider
      value={{
        show,
        setShow,
        isHeroActive,
        setIsHeroActive,
      }}
    >
      {props.children}
    </GlobalContext.Provider>
  );
};

export default GlobalContextProvider;
